// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';
export function getBasicWarrantyColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'description',
            field: 'description',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DESCRIPTION'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'model',
            field: 'model',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('MODEL'),
            width: 100

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'account',
            field: 'account',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('ACCOUNT'),
            width: 100

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'name',
            field: 'name',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER'),
            width: 200

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'location',
            field: 'location',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LOCATION'),
            width: 200

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'invoiceDate',
            field: 'invoiceDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('INVOICED'),
            width: 120
        },

        {
            cellClass: classNames.cellRightClassName,
            colId: 'currentAmountOfUse',
            field: 'currentAmountOfUse',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('CURRENT_AMOUNT_OF_USE'),
            width: 240

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'unit',
            field: 'unit',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('UNIT'),
            width: 100
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'exceedsDemoThreshold',
            field: 'exceedsDemoThreshold',
            headerClass: classNames.headerClassName,
            headerName: translate('EXCEEDS_DEMO_THRESHOLD'),
            width: 215

        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'accumulatedDaysOnRent',
            field: 'accumulatedDaysOnRent',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('ACCUMULATED_DAYS_ON_RENT'),
            width: 230

        },
        {
            cellClass: classNames.cellClassName,
            colId: 'currentlyOnRent',
            field: 'currentlyOnRent',
            headerClass: classNames.headerClassName,
            headerName: translate('CURRENTLY_ON_RENT'),
            width: 175

        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'estimatedBasicDays',
            field: 'estimatedBasicDays',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('ESTIMATED_BASIC_DAYS'),
            width: 185
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'estimatedBasicDate',
            field: 'estimatedBasicDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('ESTIMATED_BASIC_DATE'),
            width: 185

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'reportDate',
            field: 'reportDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REPORT_DATE'),
            width: 120
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/report-services/column-definitions.js